module.exports = ".log-model .col-md-12 {\n  float: inherit;\n}\n.cust-modal .close {\n  margin-right: 15px;\n  position: relative;\n  z-index: 1;\n}\n.modal-table {\n  border: 0;\n}\n.show-log-table {\n    max-height: 400px;\n    overflow: auto;\n    border: 1px solid rgba(125, 127, 114, 0.4);\n}\n.modal-btns {\n    margin-top: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/member/show-log/show-log.component.css
// module id = ./src/app/member/show-log/show-log.component.css
// module chunks = main